module.exports = __webpack_public_path__ + "img/home-124226883.5fc8e990.jpg";